import { Field, RadioGroup, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { FieldSet, ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { ManageSeparationsButton } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Components';
import { SieveAdditionFieldSet } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Components/SieveAdditionFieldSet';
import { getSeparationSieveSizeIds } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Helpers';
import { PercentageType, cumulativeOptions } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/types';
import { getById } from 'Data/ViewModels/Equipment/ISieveSize';
import { combine, pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';

let TestPreparationSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const separatingSieveList = useSelector(
    combine(
      [
        pipe(createWorksheetSelector!('', false), getSeparationSieveSizeIds),
        createWorksheetSelector!('Equipment.AllSieveSizes'),
      ],
      (ids, allSieves) =>
        ids.length > 0 ? ids.map((id) => getById(allSieves, id)?.Caption ?? 'Not set').join(', ') : 'None'
    )
  );

  const percentageTypeOptions: Array<{ label: string; value: PercentageType }> = [
    { label: 'Percent Passing', value: PercentageType.PassingCumulative },
    { label: 'Percent Retained', value: PercentageType.RetainedCumulative },
    { label: 'Individual Percent Retained', value: PercentageType.RetainedIndividual },
  ];

  return (
    <NamePrefixModifier appendNamePrefix="Preparation">
      <ListFieldSection>
        <Field
          input={<RadioGroup />}
          label="Sieve Retained Masses Are"
          name="AreSieveMassesCumulative"
          options={[
            { label: 'Cumulative', value: true },
            { label: 'Individual', value: false },
          ]}
        />
        <Field
          input={<RadioGroup />}
          label="Calculate and Apply Limits to"
          name="PercentageType"
          options={percentageTypeOptions}
        />
        <Field
          input={<RadioGroup />}
          label="Final Pan Mass Is"
          name="ArePanMassesCumulative"
          options={cumulativeOptions}
        />
        <SieveAdditionFieldSet />
      </ListFieldSection>
      <ListFieldSection>
        <FieldSet>
          <Field input={<TextOutput />} label="Separating Sieve(s)" value={separatingSieveList} />
          <div>
            <ManageSeparationsButton maxSeparations={2} defaultSieveSizes={['4_75', '4_75']} />
          </div>
        </FieldSet>
      </ListFieldSection>
    </NamePrefixModifier>
  );
};

TestPreparationSection = withInjectedProps(TestPreparationSection);

export { TestPreparationSection };
export default TestPreparationSection;
